import gql from "graphql-tag.macro";

const queryLoadProjects = gql`
  {
    projects {
      edges {
        node {
          _id
          name
        }
      }
    }
  }
`;

export const loadProjects = async ({ client }) => {
  const {
    data: {
      projects: { edges: results },
    },
  } = await client.query({
    query: queryLoadProjects,
  });
  const appRoles = window?.app?.Duchess?.currentUser?.currentSession?.app_roles || [];
  const projects = results?.map(({ node }) => ({ id: node._id, name: node.name }));
  
  if (window?.app?.Duchess?.hasRole && window.app.Duchess.hasRole(['instance:administrator', 'masterdocs:administrator'])) {
    return projects;
  }

  if (!appRoles.length) return projects;

  const filteredProjects = projects.filter(project => 
    appRoles.some(role => role.split(":")[1] === project.id)
  );
  return filteredProjects;
};

export const fetchDocumentsInAProject = async () => {

  try {
    
    const currentProjectID = window.app.Duchess.getCookie("CurrentProjectID");
    const docs = await window.app.Duchess.fetchDocuments(currentProjectID).then(items => items);

    return docs || [];
  } catch (error) {
    // Handle error appropriately
    throw new Error(error?.message);
  }
};

